import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import ICheckBuilder from "../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "idUser" | "nuevoIngreso";
export type Buttons = "aceptar" | "cancelar";

export const asesorFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idUser",
      label: "Empleado",
      bts: { mCol: 12 },
      component: IUserSelectorBuilder,
      props: {}
    },
    {
      name: "nuevoIngreso",
      label: "Marcar como Nuevo Ingreso",
      bts: { mCol: 12 },
      component: ICheckBuilder,
      props: {}
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: {}
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: { mCol: 6 },
      component: IButtonBuilder,
      props: {}
    }
  ],
  validations: {
    idUser: {
      required: true
    }
  },
  rows: [["idUser"], ["nuevoIngreso"], ["aceptar", "cancelar"]]
};
